import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import pOtpKontrol from '../../../../api/models/pOtpKontrol';
import rOtp from '../../../../api/models/rOtp';

export default ApiBaseReducer<pOtpKontrol, IInputDataStateModel<pOtpKontrol, rOtp>, rOtp>(
  ActionSubTypes.API_OTPKONTROL,
  DefaultInputDataStateModel<pOtpKontrol, rOtp>()
);
